import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Back-Up</Title>

                    <section className="mt-2 p-3">

                        <ul>
                            <li>Scout;</li>
                            <li>Axial P.M. S/C;</li>
                            <li>Axial Osso;</li>
                            <li>Sagital P.M. C/C;</li>
                            <li>Coronal P.M. C/C;</li>
                            <li>Relatório de dose:</li>
                        </ul>
                    </section>
                </div>
            </div>
        </Container>
    )
}